export default "__VITE_ASSET__C6FbV3TD__";